import Layout from './layout';
import Sider from './Sider';
Layout.Sider = Sider;
export default Layout;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/layout/index.js
// module id = 736
// module chunks = 0